import { Button, Heading, Input, Link as ChakraLink, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FullPageForm from '../../components/FullPageForm';
import { auth, signInWithEmailAndPasswordHelper } from '../../firebase';
import LoginWithProvider from './LoginWithProvider';
import OrDivider from './OrDivider';

function Login() {
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [password, setPassword] = useState('');
    const { state }: any = useLocation();
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
    useEffect(() => {
        if (user) navigate(state?.from.pathname || '/dashboard');
    }, [user, navigate, state]);

    return (
        <FullPageForm>
            <Heading marginBottom="8" marginTop="4">
                Student Login to PathMatch
            </Heading>
            <LoginWithProvider />
            <OrDivider />
            <Input
                type="text"
                marginBottom="2"
                value={email}
                size="lg"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
            />
            <Input
                type="password"
                marginBottom="2"
                value={password}
                size="lg"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
            />
            <Button
                variant="primary"
                marginBottom="4"
                size="lg"
                onClick={() => signInWithEmailAndPasswordHelper(email, password, setErrorMessage)}
            >
                Login
            </Button>
            <Text color="red">{errorMessage}</Text>
            <ChakraLink as={Link} fontSize="12" to="/reset">
                Forgot Password
            </ChakraLink>
            <ChakraLink as={Link} fontSize="12" to="/register">
                Don't have an account? Register now
            </ChakraLink>
        </FullPageForm>
    );
}
export default Login;
